import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IViewUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IView } from '../../../ts/ServerApi/types/IView';
import { IViewAccelerationPerf } from '../../../ts/ServerApi/types/IViewAccelerationPerf';
import { IViewAccelerationStatus } from '../../../ts/ServerApi/types/IViewAccelerationStatus';

export interface IGetWorkbookAccelerationsResult extends IGetItemsResult {
  views?: IView[];
  maxStats?: IViewUsageInfo;
  viewAccelerationPerfs?: IViewAccelerationPerf[];
  viewAccelerationStatus?: IViewAccelerationStatus[];
}

export class GetWorkbookAccelerationsRequest extends Request<IGetItemsParams, IGetWorkbookAccelerationsResult> {
  constructor(params: IGetItemsParams) {
    super('getWorkbookAccelerations', params);
  }
}
